import Styles from './IntegrationInitializationContent.module.scss'
import { IntegrationInitializationComponentProps } from './types'

export const IntegrationInitializationContent = ({
  notice,
  providerName,
}: Pick<IntegrationInitializationComponentProps, 'notice' | 'providerName'>) => (
  <div>
    <div className={Styles.container}>{notice}</div>
  </div>
)
